import * as Constants from "../consts/Constants";

export class Access {
  constructor() {
    this.auth = JSON.parse(localStorage.getItem("auth"));
  }

  canDashboardAcces() {
    return this.hasRole(Constants.ROLE_ADMIN_ID);
  }

  canVisitMapsAcces() {
    return this.hasRole(Constants.ROLE_ADMIN_ID);
  }

  canBusinessAccess() {
    return this.hasRole(Constants.ROLE_ADMIN_ID);
  }

  canNewsAccess() {
    return this.hasRole(Constants.ROLE_PRESS_ADMIN_ID);
  }

  canNewsHistoryAccess() {
    return this.hasRole(Constants.ROLE_PRESS_ADMIN_ID);
  }

  canCategoriesAcces() {
    return this.hasRole(Constants.ROLE_PRESS_ADMIN_ID);
  }

  canUserAccess() {
    return this.hasRole(Constants.ROLE_ADMIN_ID);
  }

  canContactAcces() {
    return this.hasRole(Constants.ROLE_ADMIN_ID);
  }

  canEmergencyAccess() {
    return this.hasRole(Constants.ROLE_POLICE_ADMIN_ID);
  }

  canQuarentineAccess() {
    return this.hasRole(Constants.ROLE_HEALTH_ADMIN_ID);
  }

  canReportsAcces() {
    return this.hasRole(Constants.ROLE_REPORTS_ADMIN_ID);
  }

  canReservationAcces() {
    return this.hasRole(Constants.ROLE_EVENTS_ADMIN_ID);
  }

  canEventsAccess() {
    return this.hasRole(Constants.ROLE_EVENTS_ADMIN_ID);
  }

  canAccess() {
    return (
      this.hasRole(Constants.ROLE_ADMIN_ID) ||
      this.hasRole(Constants.ROLE_POLICE_ADMIN_ID) ||
      this.hasRole(Constants.ROLE_PRESS_ADMIN_ID) ||
      this.hasRole(Constants.ROLE_HEALTH_ADMIN_ID) ||
      this.hasRole(Constants.ROLE_REPORTS_ADMIN_ID) ||
      this.hasRole(Constants.ROLE_EVENTS_ADMIN_ID)
    );
  }

  hasRole(role) {
    if (this.auth !== undefined) {
      if (this.auth.role === role) {
        return true;
      }
      if (this.auth.additionalRoles !== undefined) {
        if (this.auth.additionalRoles.includes(role)) {
          return true;
        }
      }
    }
    return false;
  }
}
